export default __webpack_public_path__ + "static/media/IMG_0109.f786fa7a.f786fa7a.JPG";